// src/components/PopupPictureDisplay.js
import React, { useState, useEffect } from "react";
import "./PopupPictureUpload.css";

const PopupPictureDisplay = () => {
  const [imageData, setImageData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Function to fetch popup image from server
  const fetchImage = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/popupImage`)
      .then((res) => res.json())
      .then((data) => {
        // If no image on server, hide the popup.
        if (!data || !data.imageData) {
          setShowPopup(false);
          return;
        }
        
        // If a new image is uploaded, update and reset the dismissed flag
        if (data.imageData !== imageData) {
          setImageData(data.imageData);
          setShowPopup(true);
          setDismissed(false);
        } else if (!dismissed) {
          // If the same image is still available and not dismissed,
          // ensure the popup is visible.
          setShowPopup(true);
        } 
        // If dismissed is true, we leave showPopup as false.
      })
      .catch((error) =>
        console.error("Error fetching popup image from server:", error)
      );
  };

  useEffect(() => {
    fetchImage(); // Initial fetch
    // Poll every 60 seconds (adjust as needed)
    const interval = setInterval(() => {
      fetchImage();
    }, 60000);

    return () => clearInterval(interval);
  }, [imageData, dismissed]);

  // If no image is available or popup is hidden, render nothing
  if (!imageData || !showPopup) return null;

  return (
    <div className="popup-overlay" onClick={() => {
      setShowPopup(false);
      setDismissed(true);
    }}>
      <div className="popup" onClick={(e) => e.stopPropagation()}>
        <button className="close" onClick={() => {
          setShowPopup(false);
          setDismissed(true);
        }}>
          &times;
        </button>
        <img src={imageData} alt="Pop-up" />
      </div>
    </div>
  );
};

export default PopupPictureDisplay;
